import { render, staticRenderFns } from "./ym-sales-customer-summary.vue?vue&type=template&id=c1a42bce&"
import script from "./ym-sales-customer-summary.vue?vue&type=script&lang=js&"
export * from "./ym-sales-customer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports